import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store/module/user/auth"; 
import Login from "./pages/public/login";
import SignUp from "./pages/public/signup";
import LandingPAge from "./pages/public/landingPage";
import Services from "./pages/public/services";
import Home from "./pages/private/home";
import Skill from "./pages/private/SkillShowcase";
import Table from "./pages/private/ManageMySkills";
import AboutUs from "./pages/public/abouts";
import Clients from "./pages/public/clients";
import Contact from "./pages/public/contact";
import Projects from "./pages/public/projects";
const App = () => {
  return (
    <Provider store={store}>
      {/* Wrap the application in the Redux Provider */}
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/Login" element={<Login />} />
          <Route path="/Signup" element={<SignUp />} />
          <Route path="/LandingPAge" element={<LandingPAge />} />
          <Route path="/abouts" element={<AboutUs />} />
          <Route path="/services" element={<Services />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/" element={<LandingPAge />} />
          {/* <Route path="/" element={<SplashPage />} /> */}
          {/* Private Routes */}
          <Route path="/Home" element={<Home />} />
          <Route path="/Skill" element={<Skill />} />
          <Route path="/Table" element={<Table />} />
        </Routes>
      </Router>
    </Provider>
  );
};

export default App;
